import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
`;

const DesktopWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background: #060E18;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(138, 172, 200, 0.04) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const PhoneBezel = styled.div`
  position: relative;
  width: 390px;
  height: 844px;
  border-radius: 54px;
  background: #1A1A1A;
  padding: 12px;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.08),
    0 20px 60px rgba(0, 0, 0, 0.5),
    0 0 0 3px #0A0A0A,
    inset 0 0 0 1px rgba(255, 255, 255, 0.04);
  animation: ${fadeIn} 0.6s ease-out;

  /* Botao lateral direito (power) */
  &::before {
    content: '';
    position: absolute;
    right: -3px;
    top: 180px;
    width: 3px;
    height: 80px;
    background: #2A2A2A;
    border-radius: 0 2px 2px 0;
  }

  /* Botoes laterais esquerdos (volume) */
  &::after {
    content: '';
    position: absolute;
    left: -3px;
    top: 160px;
    width: 3px;
    height: 40px;
    background: #2A2A2A;
    border-radius: 2px 0 0 2px;
    box-shadow: 0 55px 0 #2A2A2A;
  }
`;

const Screen = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 44px;
  overflow: hidden;
  position: relative;
  background: #0B1929;
`;

const DynamicIsland = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 126px;
  height: 36px;
  background: #000;
  border-radius: 20px;
  z-index: 10;
`;

const IframeContent = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
`;

const BrandLabel = styled.div`
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.15);
  letter-spacing: 4px;
  text-transform: uppercase;
  white-space: nowrap;
`;

const PhoneFrame = ({ src }) => {
  return (
    <DesktopWrapper>
      <PhoneBezel>
        <Screen>
          <DynamicIsland />
          <IframeContent
            src={src}
            title="MF Lancamentos LP"
            allow="autoplay"
          />
        </Screen>
      </PhoneBezel>
      <BrandLabel>MF Lancamentos</BrandLabel>
    </DesktopWrapper>
  );
};

export default PhoneFrame;
